export default "__VITE_ASSET__oOeIs528__"